<template>
  <div v-if="newsList.length > 0" class="news-box">
    <router-link
      v-for="(item, key) in newsList"
      :key="`${key}-item`"
      :to="{ path: `/media/in-the-news/${item.slug}` }"
      v-slot="{ navigate }"
      custom
    >
      <div class="news-box_card" @click="navigate">
        <div
          class="image"
          :style="{
            backgroundImage: `url(${item.search_image}`,
          }"
          @click="$router.push({ path: `/media/in-the-news/${item.slug}` })"
        >
          <div class="image__preview"><p>Click to View</p></div>
        </div>
        <div class="type">In The News</div>
        <h3 class="title">{{ item.title }}</h3>
        <span class="data">{{ item.date_published }} | by {{ item.author }}</span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    newsList: Array,
  },
};
</script>

<style lang="scss" scoped>
.news-box {
  @include gridLayoutWithCalc;

  &_card {
    @include flexColumnClickable;

    .image {
      position: relative;
      @include imageContainer;
      @media screen and (max-width: $xs) {
        height: 90vw;
      }

      &__preview {
        @include imagePreview;

        p {
          @include imagePreviewParagraph;
        }
      }

      &:hover {
        .image__preview {
          @include imageHoverEffect;
        }
      }
    }

    .type {
      @include typeBadge($marginTop: 26px, $fontSize: 14px, $lineHeight: 1.8);
    }

    .title {
      @include multilineEllipsisTitle;
    }

    .data {
      @include dataCaptionUppercase;
    }
  }
}
</style>

